module.exports = {"360783100":"龙南镇","360783101":"武当镇","360783102":"杨村镇","360783103":"汶龙镇","360783104":"程龙镇","360783105":"关西镇","360783106":"里仁镇","360783107":"渡江镇","360783108":"九连山镇","360783200":"桃江乡","360783201":"东江乡","360783202":"临塘乡","360783203":"南亨乡","360783204":"夹湖乡","360783400":"江西龙南经济技术开发区","360783500":"安基山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360783.json
// module id = 1417
// module chunks = 0